import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import './FrameLayout.scss';
import { _className } from '../../utils/tools.js';
export class FrameLayout extends Component {
    render() {
        const { children, ...props } = this.props;
        return _jsx("div", { ...props, className: _className(props.className, 'frame-layout'), children: children });
    }
}
//# sourceMappingURL=FrameLayout.js.map